import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import {submit} from "redux-form";
import PropTypes from "prop-types";
import compose from "recompose/compose";
import {connect} from "react-redux";
import React from "react";
import ImportZonesForm from "./ImportZonesForm";

const ImportZonesDialog = ({open, onSubmit, onCancel, submitting, dispatch, tenants}) => (
  <Dialog open={open} fullWidth={true} onClose={onCancel}>
    <DialogTitle>Import stref</DialogTitle>
    <DialogContent>
      <ImportZonesForm
        onSubmit={onSubmit}
        tenants={tenants}
      />
      <Box>
        <Box style={{color: "#ff1616", display: "flex", flexDirection: 'row', gap: 5}}>
          <Box style={{fontWeight: "900"}}>UWAGA:</Box>
          <Box>Obecne strefy zostaną usunięte</Box>
        </Box>
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={submitting}>
        Anuluj
      </Button>
      <Button
        disabled={submitting}
        color="primary"
        variant="contained"
        onClick={() => dispatch(submit('importZonesForm'))}
      >
        Importuj
      </Button>
    </DialogActions>
  </Dialog>
);

ImportZonesDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  tenants: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default compose(
  connect(),
)(ImportZonesDialog);
